module.exports = __webpack_public_path__ + "media/images/icon-servicecenter@3x-4b11f6e5dd8d92f6f6cadecf87d3765f.png";